/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Groups_DescInputs */

const en_no_groups_desc = /** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No groups joined yet`)
};

const es_no_groups_desc = /** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aún no te has unido a ningún grupo`)
};

const fr_no_groups_desc = /** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun groupe rejoint pour le moment`)
};

const de_no_groups_desc = /** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Noch keinen Gruppen beigetreten`)
};

const id_no_groups_desc = /** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Belum bergabung dengan grup`)
};

/** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */
const ja_no_groups_desc = en_no_groups_desc;

/** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */
const zh_no_groups_desc = en_no_groups_desc;

/** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */
const ar_no_groups_desc = en_no_groups_desc;

/** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */
const it_no_groups_desc = en_no_groups_desc;

/** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */
const ru_no_groups_desc = en_no_groups_desc;

/** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */
const pt_no_groups_desc = en_no_groups_desc;

/** @type {(inputs: No_Groups_DescInputs) => LocalizedString} */
const ko_no_groups_desc = en_no_groups_desc;

/**
* | output |
* | --- |
* | "No groups joined yet" |
*
* @param {No_Groups_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const no_groups_desc = /** @type {((inputs?: No_Groups_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Groups_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_no_groups_desc(inputs)
	if (locale === "es") return es_no_groups_desc(inputs)
	if (locale === "fr") return fr_no_groups_desc(inputs)
	if (locale === "de") return de_no_groups_desc(inputs)
	if (locale === "ja") return ja_no_groups_desc(inputs)
	if (locale === "zh") return zh_no_groups_desc(inputs)
	if (locale === "ar") return ar_no_groups_desc(inputs)
	if (locale === "id") return id_no_groups_desc(inputs)
	if (locale === "it") return it_no_groups_desc(inputs)
	if (locale === "ru") return ru_no_groups_desc(inputs)
	if (locale === "pt") return pt_no_groups_desc(inputs)
	return ko_no_groups_desc(inputs)
});